var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagesEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 217,
    height: 142,
    viewBox: "0 0 217 142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "115.513%",
    x2: "43.737%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "82.422%",
    x2: "46.9%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M194.893 71.283C194.741 110.365 162.951 142 123.758 142c-39.288 0-71.136-31.788-71.136-71 0-3.36.233-6.665.686-9.9H31.07a6.223 6.223 0 0 1 0-12.447h51.038a6.223 6.223 0 0 0 0-12.446H52.043a6.223 6.223 0 1 1 0-12.446H70.65C83.679 9.181 102.644 0 123.758 0c30.619 0 56.72 19.308 66.747 46.39h20.272a6.223 6.223 0 1 1 0 12.447H179.578a6.223 6.223 0 0 0 0 12.446h15.315z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M5.813 48.994H16.55a5.813 5.813 0 1 1 0 11.626H5.813a5.813 5.813 0 0 1 0-11.626z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M92 126.496c0 3.694-1.467 7.524-4.542 9.097-1.296.664-5.402.407-6.958.407-5.247 0-9.5-3.253-9.5-8.5V95a2 2 0 0 1 2-2h13.803"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M91.5 126.535L86.375 93.5H73a1.5 1.5 0 0 0-1.5 1.5v32.5c0 4.76 3.79 8 9 8 .278 0 .292 0 1.338.025.863.02 1.435.027 2.033.023 1.682-.014 2.855-.142 3.36-.4 2.67-1.366 4.258-4.77 4.269-8.613z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    d: "M81.5 135.5h79.993"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M90 47h71a4 4 0 0 1 4 4v81a4 4 0 0 1-4 4H86V51a4 4 0 0 1 4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M86.5 135.5H161a3.5 3.5 0 0 0 3.5-3.5V51a3.5 3.5 0 0 0-3.5-3.5H90a3.5 3.5 0 0 0-3.5 3.5v84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    fillRule: "nonzero",
    d: "M94 55h29v22H94z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    d: "M130 56.142h27M130 62.642h27M130 69.642h27M130 75.642h27M94 86h62.6M94 92h62M94 99h57M94 106h52M94 113h48M94 120h45M94 127h26.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#64808C",
    fillRule: "nonzero",
    d: "M176.747 73.43l-11.66 14.424a.766.766 0 0 0-.175.56c.019.2.12.39.277.517a.766.766 0 0 0 .563.163c.2-.023.388-.13.511-.288l11.659-14.422a4.183 4.183 0 0 1 5.868-.618l5.667 4.596-3.466 4.28-5.017-4.056a.766.766 0 0 0-.555-.164.766.766 0 0 0-.508.276l-5.8 7.154-28.98 35.796a.76.76 0 0 0-.134.247l-2.961 9.328a.762.762 0 0 0 .243.816.762.762 0 0 0 .848.074l8.566-4.797a.76.76 0 0 0 .219-.184l33.901-41.874.873-1.069 4.424-5.463a.766.766 0 0 0 .164-.555.766.766 0 0 0-.276-.509l-6.255-5.072a5.662 5.662 0 0 0-4.168-1.226 5.686 5.686 0 0 0-3.828 2.065zm3.863 6.808l4.426 3.579-.395.485-.002.002-1.548 1.912-4.426-3.578 1.945-2.4zm-2.898 3.575l4.427 3.579-1.947 2.404-4.425-3.584 1.945-2.399zm-2.898 3.575l4.426 3.584-28.413 35.095-6.77 3.79 2.34-7.368 28.417-35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M180.61 80.238l4.426 3.579-.395.485-.002.002-1.548 1.912-4.426-3.578 1.945-2.4zM177.712 83.813l4.427 3.579-1.947 2.404-4.425-3.584z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87D5FA",
    fillRule: "nonzero",
    d: "M174.814 87.388l4.426 3.584-28.413 35.095-6.77 3.79 2.34-7.368z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    d: "M145.825 122.778l5.075 4.11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesEmpty);
export default __webpack_public_path__ + "static/media/pages-empty.b5397dcc55d4c7c221b1e3969992a5a7.svg";
export { ForwardRef as ReactComponent };